import jogo from '../../imagens/jogo.jpg'
import jogo2 from '../../imagens/jogo2.jpg'
import jogo3 from '../../imagens/jogo3.jpg'
import jogo4 from '../../imagens/jogo4.jpg'
import jogo5 from '../../imagens/jogo5.jpg'
import jogo6 from '../../imagens/jogo6.jpg'

export const jogos = [
    { id: 1, nome: 'Dark Souls', src: jogo},
    { id: 2, nome: 'Mortal Komatt 11', src: jogo2},
    { id: 3, nome: 'Call of Duty Modern Warfare 2', src: jogo3},
    { id: 4, nome: 'Biomutant', src: jogo4},
    { id: 5, nome: 'Call of Duty Modern Warfare', src: jogo5},
    { id: 6, nome: 'Battlefield 4', src: jogo6}
]